<template>
  <footer v-if="storeName.FR" :class="{ 'fr-footer': storeName.FR }">
    <FootNav :footTabs="frFootTabsItem"></FootNav>
  </footer>
  <footer v-else-if="storeName.DE_s" :class="{ 'de-s-footer': storeName.DE_s }">
    <FootNav :footTabs="de_s_FootTabsItem"></FootNav>
  </footer>
  <footer v-else-if="storeName.EE" :class="{ 'ee-footer': storeName.EE }">
    <FootNav
      :footTabs="ee_FootTabsItem"
      :storeLogo="storeLogo.ee.url"
      :logoAlt="storeLogo.ee.alt"
    ></FootNav>
  </footer>
</template>

<script>
import FootNav from "../small/FootNav";
import { mapState } from "vuex";

export default {
  name: "store-footer",
  data() {
    return {
      storeLogo: {
        ee: {
          url: require("@/assets/img/EE/EElogo.png"),
          alt: "ELEGANT-logo",
        },
      },
      frFootTabsItem: [
        { id: 1, name: "paiement" },
        { id: 2, name: "livraison" },
        { id: 3, name: "retour" },
        { id: 4, name: "après vente" },
      ],
      de_s_FootTabsItem: [
        { id: 1, name: "zahlung" },
        { id: 2, name: "lieferung" },
        { id: 3, name: "bewertung" },
        { id: 4, name: "rechnung" },
      ],
      ee_FootTabsItem: [
        { id: 1, name: "Shipping" },
        { id: 2, name: "Return" },
        { id: 3, name: "Aftersales" },
        { id: 4, name: "Feedback" },
        { id: 5, name: "Notice" },
      ],
    };
  },
  computed: {
    ...mapState("storeInfo", ["storeName"]),
  },
  components: {
    FootNav,
  },
};
</script>

<style lang="less" scoped>
.fr-footer {
  @media (min-width: 576px) {
    .wh(1366px, auto);
    .mx(auto);
  }
  .border-T(@primaryColor, 1rem);
  .mt(1rem);
  .bg-c(@neutralColor);
}
.de-s-footer {
  @media (min-width: 576px) {
    .wh(1400px, auto);
    .mx(auto);
  }
  .border-T(@neutralColor);
  .bg-c(@neutralColor);
}
.ee-footer {
  background: url("../../assets/img/EE/footer_bg.png") no-repeat center/100%
    100%;
  .border-B();
  border-width: 1rem;
}
</style>
